import { UIGameEndReturnToMapButtonController } from './UIGameEndReturnToMapButtonController.ts';
import { UIGameEndFooterController } from './UIGameEndFooterController.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { UIGameEndShareButtonController } from './UIGameEndShareButtonController.ts';
import { EndGameStateUtils } from '@colonist/game-endgame-types';
import { RankedUserStateController } from '@colonist/leaderboard-types';
import { UIReplayShareController } from '../../ui_replay/UIReplayShareController.ts';
import { UIEndGameShareImage } from '../../ui_share_image/UIEndGameShareImage.ts';
export class UIGameEndController {
    onEvent(data, eventType) {
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.BeginnerModeLevelEnd:
                this.onBeginnerModeLevelEnd(data);
                break;
            default:
                break;
        }
    }
    onEndGameScreenClose() {
        this.uiGameManager.mapController.setInteractionEnabled(true);
    }
    onEndGameScreenOpen() {
        this.uiGameManager.mapController.setInteractionEnabled(false);
    }
    // eslint-disable-next-line class-methods-use-this
    onBeginnerModeLevelEnd(data) {
        StorageWrapper.incrementBeginnerModeLevel();
    }
    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this);
    }
    get isVisible() {
        return this.uiGameManager.gameStore.getState().gameEnd.isVisible;
    }
    get endGamePlayerState() {
        return this.endGameState.players[this.uiGameManager.gameController.myColor];
    }
    setEndGameShareImageHumanSessions() {
        const playerColors = this.uiGameManager.gameController.getPlayerColors();
        for (const color of playerColors){
            const player = this.uiGameManager.gameController.getPlayerState(color);
            if (player.isActiveHumanSession) UIEndGameShareImage.activeHumansAtGameEnd.add(color);
        }
    }
    constructor(uiGameManager, endGameState, isReplayAvailable, rankedUserStates, isShownAfterLiveGame){
        this.uiGameManager = uiGameManager;
        this.winnerColor = EndGameStateUtils.getPlayersSortedByRank(endGameState.players)[0].color;
        this.isShownAfterLiveGame = isShownAfterLiveGame !== null && isShownAfterLiveGame !== void 0 ? isShownAfterLiveGame : true;
        const isRankedUserStateDefined = rankedUserStates != undefined && rankedUserStates.length != 0;
        if (isRankedUserStateDefined) {
            const deserializedRankedUserState = [];
            for (const rankedUserState of rankedUserStates){
                deserializedRankedUserState.push({
                    color: rankedUserState.color,
                    rankedState: RankedUserStateController.deserialize(rankedUserState.rankedState)
                });
            }
            this.rankedUserStates = deserializedRankedUserState;
        }
        this.endGameState = endGameState;
        this.isReplayAvailable = isReplayAvailable;
        this.returnToMapController = new UIGameEndReturnToMapButtonController(this.uiGameManager, this);
        this.shareButton = new UIGameEndShareButtonController(this.uiGameManager, this);
        this.footerController = new UIGameEndFooterController(this.uiGameManager);
        this.setEndGameShareImageHumanSessions();
        this.uiGameManager.gameStore.getState().gameEnd.setProviderProps({
            onClickHome: ()=>this.footerController.onClickHome(),
            onClickRematch: ()=>this.footerController.onClickRematch(),
            onClickPlayAgain: ()=>this.footerController.onClickPlayAgain(),
            onClickRetryBeginnerMode: ()=>this.footerController.onClickRetryBeginnerMode(),
            onClickNextLevelBeginnerMode: ()=>this.footerController.onClickNextLevelBeginnerMode(),
            onClickShare: ()=>this.shareButton.onClickShare(),
            onClickStatsOrReplay: ()=>this.returnToMapController.onClickButton(),
            onEndGameScreenOpen: ()=>this.onEndGameScreenOpen(),
            onEndGameScreenClose: ()=>this.onEndGameScreenClose(),
            gameEndData: {
                endGameState: this.endGameState,
                rankedUserStates: this.rankedUserStates,
                isReplayAvailable: this.isReplayAvailable
            }
        });
        this.uiGameManager.gameStore.getState().gameEnd.setEndControls({
            onClickStatsOrReplay: ()=>this.returnToMapController.onClickButton(),
            onClickShareReplay: ()=>{
                var _this_uiGameManager_gameStore_getState_gameReplay_replayControls;
                const replayControlsOnShare = (_this_uiGameManager_gameStore_getState_gameReplay_replayControls = this.uiGameManager.gameStore.getState().gameReplay.replayControls) === null || _this_uiGameManager_gameStore_getState_gameReplay_replayControls === void 0 ? void 0 : _this_uiGameManager_gameStore_getState_gameReplay_replayControls.onShare;
                if (replayControlsOnShare) return replayControlsOnShare();
                void UIReplayShareController.shareOrCopyLink(this.uiGameManager.gameController);
            },
            onClickShareGameResults: ()=>this.shareButton.onClickShare()
        });
        this.uiGameManager.gameStore.getState().gameEnd.setIsVisible(true);
        this.uiGameManager.gameStore.getState().gameEnd.setIsAfterLiveGame(this.isShownAfterLiveGame);
        this.onEndGameScreenOpen();
    }
}
